import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

function LoginPage() {
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");
  const [showPass, setShowPass] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = () => {
    // simple static login (safe for now)
    if (user === "admin" && pass === "kataria@123") {
      login();
      navigate("/");
    } else {
      alert("Invalid credentials");
    }
  };

  return (
    <div
      style={{
        height: "100vh",
        display: "grid",
        placeItems: "center",
        background: "linear-gradient(135deg, #1e3c72, #2a5298)",
        fontFamily: "Arial, sans-serif"
      }}
    >
      <div
        style={{
          width: 360,
          padding: 35,
          borderRadius: 16,
          background: "#ffffff",
          boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
          textAlign: "center"
        }}
      >
        <h2 style={{ marginBottom: 10, color: "#1e3c72" }}>
          Kataria WhatsApp Panel
        </h2>
        <p style={{ fontSize: 14, color: "#666", marginBottom: 25 }}>
          Please login to continue
        </p>

        <input
          placeholder="Username"
          value={user}
          onChange={(e) => setUser(e.target.value)}
          style={{
            width: "100%",
            padding: 12,
            marginBottom: 15,
            borderRadius: 8,
            border: "1px solid #ccc",
            outline: "none"
          }}
        />

        <div style={{ position: "relative", marginBottom: 20 }}>
          <input
            type={showPass ? "text" : "password"}
            placeholder="Password"
            value={pass}
            onChange={(e) => setPass(e.target.value)}
            style={{
              width: "100%",
              padding: 12,
              borderRadius: 8,
              border: "1px solid #ccc",
              outline: "none"
            }}
          />

          <span
            onClick={() => setShowPass(!showPass)}
            style={{
              position: "absolute",
              right: 12,
              top: 12,
              cursor: "pointer",
              fontSize: 14,
              color: "#555"
            }}
          >
            {showPass ? "Hide" : "Show"}
          </span>
        </div>

        <button
          onClick={handleLogin}
          style={{
            width: "100%",
            padding: 12,
            background: "#2a5298",
            color: "#fff",
            border: "none",
            borderRadius: 8,
            fontWeight: "bold",
            cursor: "pointer",
            transition: "0.3s"
          }}
          onMouseOver={(e) => (e.target.style.background = "#1e3c72")}
          onMouseOut={(e) => (e.target.style.background = "#2a5298")}
        >
          Login
        </button>
      </div>
    </div>
  );
}

export default LoginPage;
